import React from 'react';
import NotificationPopup from 'components/notification/NotificationPopup';

const MobileNotifications = () => {
    return (
        <div style={{padding: '10px'}}>
            <NotificationPopup onHide={() => {
            }}/>
        </div>
    );
};

export default MobileNotifications;